export default {"src":"/_next/static/media/user_bold.fb0f7428.svg","height":24,"width":24};